import PropTypes from 'prop-types';

import Tooltip from '../Tooltip';

const FormRow = ({ label, name, tooltip, source, children, className = '', auto, dataSources }) => {
  const nodeLabelClasses = 'group-[.node]:pt-0';
  return (
    <div className="flex group-[.node]:flex-col gap-4 group-[.node]:gap-0">
      <div className={`pb-2 pt-1 relative flex justify-between ${nodeLabelClasses} ${className} flex-1`}>
        {label && (
          <div className="flex items-center gap-1 self-center h-5">
            <label htmlFor={name} className="block truncate text-xs font-semibold">
              {label}
            </label>
            {tooltip && <Tooltip label={label} text={tooltip} source={source} />}
          </div>
        )}
        {dataSources}
        {auto}
      </div>
      <div className={`pb-2 ${className} flex items-start flex-1 group-[.node]:grow-[2]`}>{children}</div>
    </div>
  );
};

FormRow.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  tooltip: PropTypes.string,
  source: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  auto: PropTypes.node,
  dataSources: PropTypes.node,
};

export default FormRow;
